import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/analiticas";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllAnaliticasByTax(params.tratamientoId);
}

export function AnaliticasList(props) {
  const [analiticasList, setAnaliticas] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllAnaliticasByTax(props.id).then(setAnaliticas).catch(console.log);
  }, [props.id]);
  return (
    <>
      {analiticasList?.length ? (
        <ul className='analiticas cpt-list'>
          {analiticasList
            .sort((a, b) => {
              // Parse the dates from the meta objects
              const dateA = a.meta.analiFechaAnali ? new Date(a.meta.analiFechaAnali) : new Date(a.meta.metaFecha);
              const dateB = b.meta.analiFechaAnali ? new Date(b.meta.analiFechaAnali) : new Date(b.meta.metaFecha);
              // Compare the dates (descending order)
              return dateB - dateA;
            })
            .map((analiticas) => (
              <li key={analiticas.id}>
                <NavLink to={`${props.id}/analiticas/${analiticas.id}`}>
                  {analiticas.meta.analiFechaAnali && analiticas.meta.analiFechaAnali !== '' ?
                    FormatDate(analiticas.meta.analiFechaAnali) :
                    FormatDate(analiticas.meta.metaFecha)
                  }
                </NavLink>
              </li>
            ))}
        </ul>

      ) : (
        <></>
      )}
    </>
  );
}

export function AnaliticasListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id='content'>
        <h1>Analiticas</h1>
      </div>
      <div id='actions'>
        {(props.userRole.includes('administrador') ||
          props.userRole.includes('psicologia')) && (
          <Link className='button is-link' to={`new`}>
            Nuevo
          </Link>
        )}
      </div>
    </>
  );
}
